import * as Yup from "yup";
import axios from "axios";
import { PHONE_VALIDATION_REGEX } from "../../constants/RegexConstants";

export const LOGIN_VALIDATION = Yup.object({
  email: Yup.string()
    .required("An email address is required")
    .email("Please enter a valid email address (e.g., name@example.com)")
    .matches(/@/, 'Your email address must contain an "@" symbol')
    .matches(
      /\.[a-z]{2,}$/,
      'Please include a domain name (e.g., gmail.com) after "@"'
    )
    .min(5, "The email address is too short to be valid")
    .max(320, "Email addresses cannot exceed 320 characters"),

  password: Yup.string()
    .required("Please enter your password.")
    .min(8, "Password too short - Passwords must be at least 8 characters long")
    .max(64, "Password too long - Passwords cannot exceed 64 characters")
    .test(
      "correct-password",
      "Incorrect password. Please check and re-enter.",
      (value) => {
        return value ? true : false;
      }
    ),
});

export const FORGOT_PASSWORD_VALIDATION = Yup.object({
  email: Yup.string()
    .required("An email address is required")
    .email("Please enter a valid email address (e.g., name@example.com)")
    .matches(/@/, 'Your email address must contain an "@" symbol')
    .matches(
      /\.[a-z]{2,}$/,
      'Please include a domain name (e.g., gmail.com) after "@"'
    )
    .min(5, "The email address is too short to be valid")
    .max(320, "Email addresses cannot exceed 320 characters"),
});

export const REGISTRATION_STEP_ONE = Yup.object({
  email: Yup.string()
    .email("Please enter a valid email address (e.g., name@example.com)")
    .matches(/@/, 'Your email address must contain an "@" symbol')
    .matches(
      /\.[a-z]{2,}$/,
      'Please include a domain name (e.g., gmail.com) after "@"'
    )
    .min(5, "The email address is too short to be valid")
    .max(320, "Email addresses cannot exceed 320 characters")
    .test(
      "unique-email",
      "This email is already in use. Please use a different one.",
      async (value) => {
        if (!value) return true;
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_URL}/auth/check-email?email=${value}`,
            {
              headers: {
                "X-Client-Type": "web",
              },
            }
          );
          return response.data.available;
        } catch (error) {
          return false;
        }
      }
    )
    .required("An email address is required"),
  password: Yup.string()

    .min(8, "Password too short - Passwords must be at least 8 characters long")
    .max(64, "Password too long - Passwords cannot exceed 64 characters")
    .matches(/[A-Z]/, "Password must contain at least one uppercase letter")
    .matches(/[a-z]/, "Password must contain at least one lowercase letter")
    .matches(
      /(\d|[!@#$%^&*(),.?":{}|<>\\/-])/,
      "Password must contain at least one number or special character"
    )
    .required("Please enter your password."),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password")], "Passwords must match")
    .required("Please confirm your password"),
});

export const REGISTRATION_STEP_TWO = Yup.object({
  role: Yup.string().required("Role is required"),
});

export const REGISTRATION_STEP_THREE = Yup.object({
  name: Yup.string().required("Name is required"),
  phone: Yup.string()
    .required("Phone is required")
    .matches(PHONE_VALIDATION_REGEX, "Please enter a valid phone number"),
});

export const EDIT_ASSIGNOR_VALIDATION = Yup.object({
  name: Yup.string().required("Name is required"),
  phone: Yup.string()
    .required("Phone is required")
    .matches(PHONE_VALIDATION_REGEX, "Please enter a valid phone number"),
});

export const EDIT_CONTRACTOR_VALIDATION = Yup.object({
  phone: Yup.string()
    .required("Phone is required")
    .matches(PHONE_VALIDATION_REGEX, "Please enter a valid phone number"),
});

export const EDIT_SUPERVISOR_VALIDATION = Yup.object({
  phone: Yup.string()
    .required("Phone is required")
    .matches(PHONE_VALIDATION_REGEX, "Please enter a valid phone number"),
});

export const CREATE_USER_VALIDATION = Yup.object({
  name: Yup.string().required("Name is required"),
  role: Yup.string().required("Role is required"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  phone: Yup.string()
    .transform((value) => {
      if (!value) return value;
      return value.replace(/\s+/g, "");
    })
    .matches(PHONE_VALIDATION_REGEX, "Invalid phone number")
    .required("Phone number is required"),

  password: Yup.string()
    .matches(
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&()_+\-=\[\]{};':"\\|,.<>\/?\d]).{8,}$/,
      "Password must be at least 8 characters, include uppercase, lowercase, and a number or special character"
    )
    .required("Password is required"),
});
